import request from './request';

export const getMyReportList = (params) => request.get('/reports/my/list', { params });
export const getMyReportSummary = () => request.get('/reports/my/summary');
export const getMyReportDetail = (id) => request.get(`/reports/my/${id}`);
export const saveMyReport = (payload) => request.post('/reports/my/save', payload);
export const deleteMyReport = (id) => request.post(`/reports/my/${id}/delete`);
export const deleteMyReportSourceDocument = (id) => request.delete(`/reports/my/${id}/source-document`);

export const getAdminReportSummary = () => request.get('/reports/admin/summary');
export const getAdminReportList = (params) => request.get('/reports/admin/list', { params });
export const getAdminReportDetail = (id) => request.get(`/reports/admin/${id}`);
export const deleteAdminReport = (id) => request.post(`/reports/admin/${id}/delete`);
export const deleteAdminReportSourceDocument = (id) =>
  request.delete(`/reports/admin/${id}/source-document`);
export const reviewAdminReport = (id, payload) => request.post(`/reports/admin/${id}/review`, payload);
